module.exports = __webpack_public_path__ + "img/icon-home-re-04.2c678606.jpg";